import { render, staticRenderFns } from "./PetOwnerForgetPasswordOTP.vue?vue&type=template&id=1ceda2f4&scoped=true&"
import script from "./PetOwnerForgetPasswordOTP.vue?vue&type=script&lang=js&"
export * from "./PetOwnerForgetPasswordOTP.vue?vue&type=script&lang=js&"
import style0 from "./PetOwnerForgetPasswordOTP.vue?vue&type=style&index=0&id=1ceda2f4&prod&lang=scss&scoped=true&"
import style1 from "./PetOwnerForgetPasswordOTP.vue?vue&type=style&index=1&id=1ceda2f4&prod&lang=scss&scoped=true&"
import style2 from "./PetOwnerForgetPasswordOTP.vue?vue&type=style&index=2&id=1ceda2f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ceda2f4",
  null
  
)

export default component.exports